// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import ElementUI from "element-ui";

import lang from "element-ui/lib/locale/lang/tr-TR";
import locale from "element-ui/lib/locale";
import Vuex from "vuex";
import axios from "axios";

import VueTheMask from "vue-the-mask";
Vue.use(VueTheMask);

//axios.defaults.baseURL = "http://localhost:5000/tr/";
axios.defaults.baseURL = "https://www.ingilizcemulakat.com/tr/";

function take(c) {
  return this.filter((x, i) => {
    if (i <= c - 1) {
      return true;
    }
  });
}

Array.prototype.take = take;

function skip(c) {
  return this.filter((x, i) => {
    if (i > c - 1) {
      return true;
    }
  });
}

Array.prototype.skip = skip;

Vue.prototype.$checkBrowser = () => {
  var isOpera =
    (!!window.opr && !!opr.addons) ||
    !!window.opera ||
    navigator.userAgent.indexOf(" OPR/") >= 0;
  if (isOpera) return "opera";

  var isFirefox = typeof InstallTrigger !== "undefined";
  if (isFirefox) return "firefox";

  var isSafari =
    /constructor/i.test(window.HTMLElement) ||
    (function (p) {
      return p.toString() === "[object SafariRemoteNotification]";
    })(
      !window["safari"] ||
      (typeof safari !== "undefined" && safari.pushNotification)
    );
  if (isSafari) return "safari";

  var isChrome =
    !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);
  if (isChrome) return "chrome";

  return null;
};

Vue.prototype.$helpLinks = {
  chrome:
    "https://support.google.com/chrome/answer/2693767?co=GENIE.Platform%3DDesktop&hl=tr",
  mozilla:
    "https://support.mozilla.org/tr/kb/how-manage-your-camera-and-microphone-permissions",
  opera: "https://help.opera.com/en/latest/web-preferences/#camera",
  safari: "https://support.apple.com/tr-tr/guide/safari/ibrwe2159f50/mac",
};

Vue.use(ElementUI);
Vue.use(Vuex);
locale.use(lang);

Vue.config.productionTip = false;

const store = new Vuex.Store({
  state: {
    key: null,
    form: {
      firstName: null,
      lastName: null,
      email: null,
      photo: null,
    },
    token: null,
    section: null,
    currentSection: 0,
    nextSectionMessage: null,
    sectionInfos: [],
    firm: null,
    department: null,
    sectionHistory: [],
    exam: null,
  },
  mutations: {
    setSection(state, data) {
      state.section = data;
      if (state.section != null) {
        state.sectionHistory.push(state.section);
      }
    },
    setPhoto(state, data) {
      // console.log(data)
      state.form.photo = data;
    },
  },
});

window.vm = new Vue({
  data() {
    return {
      interval: null,
    };
  },
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
  store,
  methods: {
    startRecording() { },
    stopRecording() {
      clearInterval(this.interval);
      this.$store.state.isRecording = false;
    },
    uploadRecord() { },
  },
  beforeMount() {
    this.$root.$on("startRecording", (data) => {
      this.startRecording();
    });

    this.$root.$on("stopRecording", (data) => {
      this.stopRecording();
    });
  },
  mounted() {
    this.startRecording();
  },
});



// WEBPACK FOOTER //
// ./src/main.js